// @flow

import routes from 'app/onboarding/routes';

export default {
  routes,
};
